import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import package1 from "../assets/Tour Packages/800x750-4.jpg";
import package2 from "../assets/Tour Packages/galle-fort.jpg";
import package3 from "../assets/Tour Packages/58bedaa4bd709f22008b45f6.webp";
import package4 from "../assets/Tour Packages/SL_Kandy_asv2020-01_img04_Queens_Hotel.jpg";
import package5 from "../assets/Tour Packages/sigiriya-640x360.jpg";
import package6 from "../assets/Tour Packages/caption.jpg";
import package7 from "../assets/Tour Packages/12.jpg";
import package8 from "../assets/Tour Packages/photo-1568430328012-21ed450453ea.jpg";
import package9 from "../assets/Tour Packages/772360437921620.jpg";
import package10 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage.png";
import package11 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage (1).png";
import package12 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage (2).png";
import package13 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage.png";
import package14 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage (3).png";
import package15 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage (4).png";
import package16 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage (5).png";
import package17 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage (6).png";
import package18 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage (7).png";
import package19 from "../assets/Tour Packages/Beige Minimalist Mood Photo Collage (8).png";
import package21 from "../assets/Tour Packages/WhatsApp Image 2025-02-08 at 21.18.17.jpeg";
import package22 from "../assets/Tour Packages/kandy-1.jpg";
import backgroundImage from "../assets/ashan/12.jpeg";
import destination1 from "../assets/Tour Packages/Ravana-Falls-Waterfall.jpg";
import destination2 from "../assets/Tour Packages/elephant-transit-home-udawalawe-1-scaled.jpg";
import destination3 from "../assets/Tour Packages/mini-adams-peak-1-7.jpg";
import destination4 from "../assets/Tour Packages/1.jpeg";
import destination5 from "../assets/Tour Packages/23.jpeg";
import destination6 from "../assets/Tour Packages/19.jpeg";
import destination7 from "../assets/Tour Packages/Herbal-Garden-Tour-1.jpg";
import destination8 from "../assets/Tour Packages/9.jpeg";
import destination9 from "../assets/Tour Packages/kande-viharaya-buddhist-temple.jpg";
import destination10 from "../assets/Tour Packages/sea-turtle-farm-and-hatchery.jpg";
import destination11 from "../assets/Tour Packages/images.jpeg";
import destination12 from "../assets/Tour Packages/snorkel-mirissa-589x392.avif";
import destination13 from "../assets/Tour Packages/Herbal-Garden-Tour-1.jpg";
import destination15 from "../assets/Tour Packages/25 (2).jpg";
import destination16 from "../assets/Tour Packages/kandy-1.jpg";
import destination17 from "../assets/Tour Packages/Kandy-Sri-Lanka1-819x1024.jpg";
import destination18 from "../assets/Tour Packages/temple-of-the-sacred-tooth-relic-kandy.jpg";
import destination19 from "../assets/Tour Packages/574f7bf01a37eff2f3dec3d2bed00141_izdeliya.jpg";
import destination20 from "../assets/Tour Packages/silk_02.jpg";
import destination21 from "../assets/Tour Packages/images (1).jpeg";
import destination22 from "../assets/Tour Packages/Herbal-Garden-Tour-1.jpg";
import destination23 from "../assets/Tour Packages/36.jpeg";
import destination24 from "../assets/Tour Packages/sigiriya-lion-rock-8.jpg.webp";
import destination25 from "../assets/Tour Packages/28.jpeg";
import destination26 from "../assets/Tour Packages/Sigiriya-village-lunch.webp";
import destination27 from "../assets/Tour Packages/22.jpg";
import destination28 from "../assets/Tour Packages/Herbal-Garden-Tour-1.jpg";
import destination29 from "../assets/Tour Packages/70431288-Elephants-safari-to-the-Udawalawe-National-Park-Sri-Lanka.jpg";
import destination30 from "../assets/Tour Packages/1.jpg";
import destination31 from "../assets/Tour Packages/elephant-transit-home-udawalawe-1-scaled.jpg";
import destination32 from "../assets/Tour Packages/the-colombo-lotus-tower.jpg";
import destination33 from "../assets/Tour Packages/images (2).jpeg";
import destination34 from "../assets/Tour Packages/shopping.webp";
import destination35 from "../assets/Tour Packages/Herbal-Garden-Tour-1.jpg";
import destination36 from "../assets/Tour Packages/COCONUTHILL-7-of-12-2-scaled-scaled.jpg";
import destination37 from "../assets/Tour Packages/S4.jpg";
import destination38 from "../assets/Tour Packages/sri-lanka-blue-whale.webp";
import destination39 from "../assets/Tour Packages/Herbal-Garden-Tour-1.jpg";
import destination40 from "../assets/Tour Packages/WhatsApp Image 2025-02-08 at 21.18.17 2.jpeg";
import destination41 from "../assets/Tour Packages/40.jpeg";
import destination43 from "../assets/Tour Packages/kande-viharaya-buddhist-temple.jpg";
import destination44 from "../assets/Tour Packages/574f7bf01a37eff2f3dec3d2bed00141_izdeliya.jpg";
import destination45 from "../assets/Tour Packages/Herbal-Garden-Tour-1.jpg";
import destination46 from "../assets/Tour Packages/free-breakfast-hotels.jpg";
import destination47 from "../assets/Tour Packages/gadaladeniya-entire-temple_orig.jpg";
import destination48 from "../assets/Tour Packages/Kandyan-and-Sri-Lankan-Traditional-Dances.jpg";
import destination49 from "../assets/Tour Packages/temple-of-the-sacred-tooth-relic-kandy.jpg";
import destination50 from "../assets/Tour Packages/Herbal-Garden-Tour-1.jpg";
import destination51 from "../assets/Tour Packages/34.jpeg";
import destination52 from "../assets/Tour Packages/34.jpeg";
import destination53 from "../assets/Tour Packages/Gregory-Lake-Nuwara-Eliya-974x530.jpg";
import destination54 from "../assets/Tour Packages/images (3).jpeg";
import destination55 from "../assets/Tour Packages/horton9-min.jpg";
import luxuryTransport1 from "../assets/ashan/coaster-bus_orig.jpg";
import luxuryTransport2 from "../assets/ashan/8449390_orig.jpg";

const TourPackages = () => {
    const { t } = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [visibleCount, setVisibleCount] = useState(1);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const packages = [
        {
            image: package1,
            title: t("tourPackages.packages.ella.title"),
            duration: t("tourPackages.packages.ella.duration"),
            location: t("tourPackages.packages.ella.location"),
            description: t("tourPackages.packages.ella.description"),
            destinations: [
                t("tourPackages.destinations.ravanaWaterfall"),
                t("tourPackages.destinations.nineArchBridge"),
                t("tourPackages.destinations.teaPlantation"),
                t("tourPackages.destinations.trainRide"),
                t("tourPackages.destinations.littleAdamsPeak"),
                t("tourPackages.destinations.udawalaweElephant"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
            ],
            destinationImages: [destination1, destination2, destination3, destination4, destination5, destination6, destination7],
        },
        {
            image: package2,
            title: t("tourPackages.packages.galleFort.title"),
            duration: t("tourPackages.packages.galleFort.duration"),
            location: t("tourPackages.packages.galleFort.location"),
            description: t("tourPackages.packages.galleFort.description"),
            destinations: [
                t("tourPackages.destinations.templeKandeViharaya"),
                t("tourPackages.destinations.turtleHatchery"),
                t("tourPackages.destinations.boatSafari"),
                t("tourPackages.destinations.moonstoneMine"),
                t("tourPackages.destinations.hikkaduwaBeach"),
                t("tourPackages.destinations.dutchFortGalle"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
            ],
            destinationImages: [destination8, destination9, destination10, destination11, destination12, destination13],
        },
        {
            image: package3,
            title: t("tourPackages.packages.yalaSafari.title"),
            duration: t("tourPackages.packages.yalaSafari.duration"),
            location: t("tourPackages.packages.yalaSafari.location"),
            description: t("tourPackages.packages.yalaSafari.description"),
            destinations: [t("tourPackages.destinations.yala"), t("tourPackages.destinations.yalaSafariJeep")],
            destinationImages: [destination15],
        },
        {
            image: package4,
            title: t("tourPackages.packages.kandy.title"),
            duration: t("tourPackages.packages.kandy.duration"),
            location: t("tourPackages.packages.kandy.location"),
            description: t("tourPackages.packages.kandy.description"),
            destinations: [
                t("tourPackages.destinations.kandy"),
                t("tourPackages.destinations.royalBotanicalGarden"),
                t("tourPackages.destinations.teaFactoryPlantation"),
                t("tourPackages.destinations.elephantFeeding"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.ambuluwawaTowerOrTemple"),
                t("tourPackages.destinations.jewelleryGemFactory"),
                t("tourPackages.destinations.silkFactory"),
            ],
            destinationImages: [destination16, destination17, destination18, destination19, destination20, destination21, destination22, destination23],
        },
        {
            image: package5,
            title: t("tourPackages.packages.sigiriya.title"),
            duration: t("tourPackages.packages.sigiriya.duration"),
            location: t("tourPackages.packages.sigiriya.location"),
            description: t("tourPackages.packages.sigiriya.description"),
            destinations: [
                t("tourPackages.destinations.sigiriya"),
                t("tourPackages.destinations.sigiriyaLionRock"),
                t("tourPackages.destinations.dambullaGoldenTemple"),
                t("tourPackages.destinations.villageTour"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.pidurangalaRock"),
            ],
            destinationImages: [destination24, destination25, destination26, destination27, destination28],
        },
        {
            image: package6,
            title: t("tourPackages.packages.udawalawe.title"),
            duration: t("tourPackages.packages.udawalawe.duration"),
            location: t("tourPackages.packages.udawalawe.location"),
            description: t("tourPackages.packages.udawalawe.description"),
            destinations: [
                t("tourPackages.destinations.udawalawe"),
                t("tourPackages.destinations.udawalaweNationalPark"),
                t("tourPackages.destinations.jeepSafari"),
                t("tourPackages.destinations.elephantMilkFeeding"),
            ],
            destinationImages: [destination29, destination30, destination31],
        },
        {
            image: package7,
            title: t("tourPackages.packages.colomboCityEscape.title"),
            duration: t("tourPackages.packages.colomboCityEscape.duration"),
            location: t("tourPackages.packages.colomboCityEscape.location"),
            description: t("tourPackages.packages.colomboCityEscape.description"),
            destinations: [
                t("tourPackages.destinations.lotusTower"),
                t("tourPackages.destinations.redMosque"),
                t("tourPackages.destinations.shopping"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
            ],
            destinationImages: [destination32, destination33, destination34, destination35],
        },
        {
            image: package8,
            title: t("tourPackages.packages.mirissaWhaleWatching.title"),
            duration: t("tourPackages.packages.mirissaWhaleWatching.duration"),
            location: t("tourPackages.packages.mirissaWhaleWatching.location"),
            description: t("tourPackages.packages.mirissaWhaleWatching.description"),
            destinations: [
                t("tourPackages.destinations.blueWhales"),
                t("tourPackages.destinations.mirissa"),
                t("tourPackages.destinations.stiltFishing"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
            ],
            destinationImages: [destination36, destination37, destination38, destination39],
        },
        {
            image: package21,
            title: t("tourPackages.packages.mirissaWhaleWatchingComfort.title"),
            duration: t("tourPackages.packages.mirissaWhaleWatchingComfort.duration"),
            location: t("tourPackages.packages.mirissaWhaleWatchingComfort.location"),
            description: t("tourPackages.packages.mirissaWhaleWatchingComfort.description"),
            destinations: [
                t("tourPackages.destinations.blueWhales"),
                t("tourPackages.destinations.mirissa"),
                t("tourPackages.destinations.stiltFishing"),
            ],
            destinationImages: [destination36, destination37, destination38, destination39, destination40, destination41],
        },
        {
            image: package9,
            title: t("tourPackages.packages.bentotaRiverSafari.title"),
            duration: t("tourPackages.packages.bentotaRiverSafari.duration"),
            location: t("tourPackages.packages.bentotaRiverSafari.location"),
            description: t("tourPackages.packages.bentotaRiverSafari.description"),
            destinations: [
                t("tourPackages.destinations.bentotaRiver"),
                t("tourPackages.destinations.bentota"),
                t("tourPackages.destinations.templeKandeViharaya"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.jewelleryGemFactory"),
            ],
            destinationImages: [destination43, destination44, destination45],
        },
        {
            image: package10,
            title: t("tourPackages.packages.ellaYala.title"),
            duration: t("tourPackages.packages.ellaYala.duration"),
            location: t("tourPackages.packages.ellaYala.location"),
            description: t("tourPackages.packages.ellaYala.description"),
            destinations: [
                t("tourPackages.destinations.ravanaWaterfall"),
                t("tourPackages.destinations.trainRide"),
                t("tourPackages.destinations.nineArchBridge"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.safariYalaNationalPark"),
                t("tourPackages.destinations.teaPlantation"),
            ],
            destinationImages: [destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination15],
        },
        {
            image: package11,
            title: t("tourPackages.packages.ellaGalle.title"),
            duration: t("tourPackages.packages.ellaGalle.duration"),
            location: t("tourPackages.packages.ellaGalle.location"),
            description: t("tourPackages.packages.ellaGalle.description"),
            destinations: [
                t("tourPackages.destinations.ravanaWaterfall"),
                t("tourPackages.destinations.nineArchBridge"),
                t("tourPackages.destinations.trainRide"),
                t("tourPackages.destinations.littleAdamsPeak"),
                t("tourPackages.destinations.dutchFortGalle"),
                t("tourPackages.destinations.teaPlantation"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
            ],
            destinationImages: [destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination8, destination9, destination10, destination11, destination12, destination13],
        },
        {
            image: package12,
            title: t("tourPackages.packages.yalaGalle.title"),
            duration: t("tourPackages.packages.yalaGalle.duration"),
            location: t("tourPackages.packages.yalaGalle.location"),
            description: t("tourPackages.packages.yalaGalle.description"),
            destinations: [t("tourPackages.destinations.safariYalaNationalPark"), t("tourPackages.destinations.dutchFortGalle")],
            destinationImages: [destination15, destination8, destination9, destination10, destination11, destination12, destination13],
        },
        {
            image: package13,
            title: t("tourPackages.packages.ellaYalaTwoDays.title"),
            duration: t("tourPackages.packages.ellaYalaTwoDays.duration"),
            location: t("tourPackages.packages.ellaYalaTwoDays.location"),
            description: t("tourPackages.packages.ellaYalaTwoDays.description"),
            destinations: [
                t("tourPackages.destinations.ravanaWaterfall"),
                t("tourPackages.destinations.trainRide"),
                t("tourPackages.destinations.nineArchBridge"),
                t("tourPackages.destinations.littleAdamsPeak"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.safariYalaNationalPark"),
                t("tourPackages.destinations.luxuryHotelStay"),
            ],
            destinationImages: [destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination15, destination46],
        },
        {
            image: package22,
            title: t("tourPackages.packages.kandyTwoDays.title"),
            duration: t("tourPackages.packages.kandyTwoDays.duration"),
            location: t("tourPackages.packages.kandyTwoDays.location"),
            description: t("tourPackages.packages.kandyTwoDays.description"),
            destinations: [
                t("tourPackages.destinations.gadoladeniyaTemple"),
                t("tourPackages.destinations.templeOfTheToothRelic"),
                t("tourPackages.destinations.traditionalKandyanDance"),
                t("tourPackages.destinations.luxuryHotelStay"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
            ],
            destinationImages: [destination47, destination48, destination49, destination50, destination46],
        },
        {
            image: package14,
            title: t("tourPackages.packages.ellaNuwaraEliyaKandy.title"),
            duration: t("tourPackages.packages.ellaNuwaraEliyaKandy.duration"),
            location: t("tourPackages.packages.ellaNuwaraEliyaKandy.location"),
            description: t("tourPackages.packages.ellaNuwaraEliyaKandy.description"),
            destinations: [
                t("tourPackages.destinations.ravanaWaterfall"),
                t("tourPackages.destinations.nineArchBridge"),
                t("tourPackages.destinations.teaPlantation"),
                t("tourPackages.destinations.trainRide"),
                t("tourPackages.destinations.littleAdamsPeak"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.teaPlantation"),
                t("tourPackages.destinations.teaFactory"),
                t("tourPackages.destinations.nuwaraEliyaTown"),
                t("tourPackages.destinations.ambuluwawaTower"),
                t("tourPackages.destinations.hinduTemple"),
                t("tourPackages.destinations.royalBotanicalGarden"),
                t("tourPackages.destinations.elephantFeeding"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.ambuluwawaTowerOrTemple"),
                t("tourPackages.destinations.jewelleryGemFactory"),
                t("tourPackages.destinations.silkFactory"),
                t("tourPackages.destinations.luxuryHotelStay"),
            ],
            destinationImages: [destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination47, destination48, destination49, destination50, destination51, destination46],
        },
        {
            image: package15,
            title: t("tourPackages.packages.kandySigiriya.title"),
            duration: t("tourPackages.packages.kandySigiriya.duration"),
            location: t("tourPackages.packages.kandySigiriya.location"),
            description: t("tourPackages.packages.kandySigiriya.description"),
            destinations: [
                t("tourPackages.destinations.sigiriyaLionRock"),
                t("tourPackages.destinations.pidurangalaRock"),
                t("tourPackages.destinations.dambullaGoldenTemple"),
                t("tourPackages.destinations.traditionalKandyanDance"),
                t("tourPackages.destinations.templeOfTheToothRelic"),
                t("tourPackages.destinations.royalBotanicalGarden"),
                t("tourPackages.destinations.ambuluwawaTower"),
                t("tourPackages.destinations.teaFactoryPlantation"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.jewelleryGemFactory"),
                t("tourPackages.destinations.silkFactory"),
                t("tourPackages.destinations.luxuryHotelStay"),
            ],
            destinationImages: [destination16, destination17, destination18, destination19, destination20, destination21, destination22, destination23, destination24, destination25, destination26, destination27, destination28],
        },
        {
            image: package16,
            title: t("tourPackages.packages.ellaNuwaraEliya.title"),
            duration: t("tourPackages.packages.ellaNuwaraEliya.duration"),
            location: t("tourPackages.packages.ellaNuwaraEliya.location"),
            description: t("tourPackages.packages.ellaNuwaraEliya.description"),
            destinations: [
                t("tourPackages.destinations.ravanaWaterfall"),
                t("tourPackages.destinations.nineArchBridge"),
                t("tourPackages.destinations.teaPlantation"),
                t("tourPackages.destinations.trainRide"),
                t("tourPackages.destinations.littleAdamsPeak"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.gregoryLake"),
                t("tourPackages.destinations.postOffice"),
                t("tourPackages.destinations.hortanPlains"),
                t("tourPackages.destinations.sitaAmmanHinduKovil"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.luxuryHotelStay"),
            ],
            destinationImages: [destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination52, destination53, destination54, destination55],
        },
        {
            image: package17,
            title: t("tourPackages.packages.sigiriKandyElla.title"),
            duration: t("tourPackages.packages.sigiriKandyElla.duration"),
            location: t("tourPackages.packages.sigiriKandyElla.location"),
            description: t("tourPackages.packages.sigiriKandyElla.description"),
            destinations: [
                t("tourPackages.destinations.sigiriya"),
                t("tourPackages.destinations.sigiriyaLionRock"),
                t("tourPackages.destinations.dambullaGoldenTemple"),
                t("tourPackages.destinations.villageTour"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.pidurangalaRock"),
                t("tourPackages.destinations.kandy"),
                t("tourPackages.destinations.botanicalGarden"),
                t("tourPackages.destinations.teaFactoryPlantation"),
                t("tourPackages.destinations.elephantFeeding"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.ambuluwawaTowerOrTemple"),
                t("tourPackages.destinations.jewelleryGemFactory"),
                t("tourPackages.destinations.silkFactory"),
                t("tourPackages.destinations.rambodaWaterfall"),
                t("tourPackages.destinations.sitaAmmanHinduKovil"),
                t("tourPackages.destinations.ravanaWaterfall"),
                t("tourPackages.destinations.nineArchBridge"),
                t("tourPackages.destinations.teaPlantation"),
                t("tourPackages.destinations.trainRide"),
                t("tourPackages.destinations.littleAdamsPeak"),
                t("tourPackages.destinations.udawalaweElephant"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.luxuryHotelStay"),
            ],
            destinationImages: [destination24, destination25, destination26, destination27, destination28, destination16, destination17, destination18, destination19, destination20, destination21, destination22, destination23, destination1, destination2, destination3, destination4, destination5, destination6, destination7],
        },
        {
            image: package18,
            title: t("tourPackages.packages.kandyNuwaraEliyaEllaYala.title"),
            duration: t("tourPackages.packages.kandyNuwaraEliyaEllaYala.duration"),
            location: t("tourPackages.packages.kandyNuwaraEliyaEllaYala.location"),
            description: t("tourPackages.packages.kandyNuwaraEliyaEllaYala.description"),
            destinations: [
                t("tourPackages.destinations.gadoladeniyaTemple"),
                t("tourPackages.destinations.templeOfTheToothRelic"),
                t("tourPackages.destinations.traditionalKandyanDance"),
                t("tourPackages.destinations.luxuryHotelStay"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.teaPlantation"),
                t("tourPackages.destinations.teaFactory"),
                t("tourPackages.destinations.gregoryLake"),
                t("tourPackages.destinations.postOffice"),
                t("tourPackages.destinations.sitaAmmanHinduKovil"),
                t("tourPackages.destinations.ayurvedicHerbalGarden"),
                t("tourPackages.destinations.luxuryHotelStay"),
                t("tourPackages.destinations.ravanaWaterfall"),
                t("tourPackages.destinations.nineArchBridge"),
                t("tourPackages.destinations.teaPlantation"),
                t("tourPackages.destinations.trainRide"),
                t("tourPackages.destinations.littleAdamsPeak"),
                t("tourPackages.destinations.luxuryHotelStay"),
                t("tourPackages.destinations.safariYalaNationalPark"),
            ],
            destinationImages: [destination47, destination48, destination49, destination50, destination46, destination52, destination53, destination54, destination55, destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination15],
        },
        {
            image: package19,
            title: t("tourPackages.packages.sigiriyaAnuradhapuraPolonnaruwaMinneriya.title"),
            duration: t("tourPackages.packages.sigiriyaAnuradhapuraPolonnaruwaMinneriya.duration"),
            location: t("tourPackages.packages.sigiriyaAnuradhapuraPolonnaruwaMinneriya.location"),
            description: t("tourPackages.packages.sigiriyaAnuradhapuraPolonnaruwaMinneriya.description"),
            destinations: [
                t("tourPackages.destinations.sigiriyaRockFortress"),
                t("tourPackages.destinations.anuradhapura"),
                t("tourPackages.destinations.polonnaruwa"),
                t("tourPackages.destinations.minneriyaNationalPark"),
                t("tourPackages.destinations.elephants"),
            ],
            destinationImages: [destination24, destination25, destination26, destination27, destination28],
        },
    ];

    const slideLeft = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? packages.length - visibleCount : prevIndex - 1
        );
    };

    const slideRight = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === packages.length - visibleCount ? 0 : prevIndex + 1
        );
    };

    const visiblePackages = packages.slice(currentIndex, currentIndex + visibleCount);

    const closeWindow = () => {
        setSelectedPackage(null);
        setSelectedImage(null);
        setCurrentImageIndex(0);
    };

    const openImage = (img, index) => {
        setSelectedImage(img);
        setCurrentImageIndex(index);
    };

    const closeImage = () => {
        setSelectedImage(null);
        setCurrentImageIndex(0);
    };

    const nextImage = () => {
        if (selectedPackage && currentImageIndex < selectedPackage.destinationImages.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
            setSelectedImage(selectedPackage.destinationImages[currentImageIndex + 1]);
        }
    };

    const prevImage = () => {
        if (currentImageIndex > 0) {
            setCurrentImageIndex(currentImageIndex - 1);
            setSelectedImage(selectedPackage.destinationImages[currentImageIndex - 1]);
        }
    };

    const handleBook = (pkg) => {
        const bookingMessage = t("tourPackages.bookingMessage", {
            title: pkg.title,
            duration: pkg.duration,
            location: pkg.location,
        });
        const whatsappUrl = `https://wa.me/94779590011?text=${encodeURIComponent(bookingMessage)}`;
        try {
            const win = window.open(whatsappUrl, "_blank");
            if (!win) {
                alert(t("tourPackages.manualBookingMessage", { message: bookingMessage, number: "+94 77 959 0011" }));
            }
        } catch (error) {
            alert(t("tourPackages.errorBookingMessage", { message: bookingMessage, number: "+94 77 959 0011" }));
        }
    };

    useEffect(() => {
        const updateVisibleCount = () => {
            if (window.innerWidth >= 1280) {
                setVisibleCount(3);
            } else if (window.innerWidth >= 768) {
                setVisibleCount(2);
            } else {
                setVisibleCount(1);
            }
        };

        updateVisibleCount();
        window.addEventListener("resize", updateVisibleCount);
        return () => window.removeEventListener("resize", updateVisibleCount);
    }, []);

    return (
        <div className="relative py-16 px-4 sm:px-8 lg:px-16 bg-gradient-to-b from-[#FFFFFF] to-[#F8F1E9] min-h-screen">
            {/* Title */}
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md animate-fade-in">
                {t("tourPackages.title")}
            </h2>

            {/* Slider */}
            <div className="relative flex items-center justify-center space-x-4 max-w-7xl mx-auto">
                {/* Left Arrow */}
                <button
                    onClick={slideLeft}
                    className="bg-[#C58E2F] text-[#FFFFFF] p-4 rounded-full hover:bg-[#A57324] transition transform hover:scale-110 z-10 shadow-lg"
                >
                    &#8249;
                </button>

                {/* Cards */}
                <div className="flex w-full justify-center space-x-6 overflow-hidden mb-20">
                    {visiblePackages.map((pkg, index) => (
                        <div
                            key={index}
                            className="w-80 bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transform transition-all duration-500 hover:scale-105 group"
                        >
                            <div className="relative overflow-hidden">
                                <img
                                    src={pkg.image}
                                    alt={pkg.title}
                                    className="w-full h-60 object-cover transition-transform duration-500 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300 flex items-center justify-center">

                                </div>
                            </div>
                            <div className="p-6 bg-[#F8F1E9] border-t-2 border-[#C58E2F]">
                                <h3 className="text-xl font-bold text-[#122C56] mb-2">{pkg.title}</h3>
                                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center text-sm text-gray-600 mb-4">
                                    <span>{pkg.location}</span>
                                    <span>{pkg.duration}</span>
                                </div>
                                <p className="text-gray-700 text-sm mb-4 line-clamp-3">{pkg.description}</p>
                                <div className="flex justify-between items-center">
                                    <button
                                        className="px-4 py-2 bg-gray-200 text-[#122C56] rounded-lg text-sm font-semibold hover:bg-gray-300 transition"
                                        onClick={() => setSelectedPackage(pkg)}
                                    >
                                        {t("tourPackages.readMore")}
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-[#C58E2F] text-[#FFFFFF] rounded-lg text-sm font-semibold hover:bg-[#A57324] transition transform hover:scale-105"
                                        onClick={() => handleBook(pkg)}
                                    >
                                        {t("tourPackages.book")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Right Arrow */}
                <button
                    onClick={slideRight}
                    className="bg-[#C58E2F] text-[#FFFFFF] p-4 rounded-full hover:bg-[#A57324] transition transform hover:scale-110 z-10 shadow-lg"
                >
                    &#8250;
                </button>
            </div>

            {/* Package Details Modal */}
            {selectedPackage && (
                <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-20">
                    <div className="bg-white w-11/12 md:w-3/4 lg:w-2/3 rounded-2xl shadow-2xl p-8 relative max-h-[90vh] overflow-y-auto transform transition-all duration-500 scale-95 hover:scale-100 border-t-4 border-[#C58E2F]">
                        {/* Close Button */}
                        <button
                            onClick={closeWindow}
                            className="absolute top-4 right-4 bg-gray-200 text-[#122C56] rounded-full p-2 hover:bg-gray-300 transition shadow-md"
                        >
                            &#10005;
                        </button>

                        {/* Modal Content */}
                        <h2 className="text-3xl font-bold text-[#122C56] mb-4 drop-shadow-md">{selectedPackage.title}</h2>
                        <p className="text-lg text-gray-700 mb-4">{selectedPackage.description}</p>
                        <h3 className="text-xl font-semibold text-[#C58E2F] mb-2">{t("tourPackages.destinationsTitle")}</h3>
                        <ul className="list-disc list-inside mb-6 text-gray-700">
                            {selectedPackage.destinations?.map((dest, i) => (
                                <li key={i} className="text-sm">{dest}</li>
                            ))}
                        </ul>
                        <div className="columns-2 sm:columns-3 lg:columns-4 gap-4 mb-6">
                            {selectedPackage.destinationImages?.map((img, i) => (
                                <div key={i} className="relative mb-4 break-inside-avoid group">
                                    <img
                                        src={img}
                                        alt={t("tourPackages.destinationImageAlt", { index: i + 1 })}
                                        className="w-full h-48 object-cover rounded-lg shadow-md cursor-pointer hover:scale-105 transition-transform duration-300"
                                        onClick={() => openImage(img, i)}
                                    />
                                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                                        <span className="text-white text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            {t("tourPackages.clickToEnlarge")}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-end">
                            <button
                                className="px-6 py-2 bg-[#C58E2F] text-[#FFFFFF] rounded-lg font-semibold hover:bg-[#A57324] transition transform hover:scale-105"
                                onClick={() => handleBook(selectedPackage)}
                            >
                                {t("tourPackages.bookNow")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Enlarged Image View Modal */}
            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-30">
                    <div className="relative w-full max-w-4xl max-h-[90vh] bg-white rounded-2xl shadow-2xl p-4 animate-fade-in">
                        <button
                            onClick={closeImage}
                            className="absolute top-4 right-4 bg-gray-200 text-[#122C56] rounded-full p-2 hover:bg-gray-300 transition shadow-md z-10"
                        >
                            &#10005;
                        </button>
                        {selectedPackage?.destinationImages?.length > 1 && (
                            <>
                                <button
                                    onClick={prevImage}
                                    className={`absolute left-4 top-1/2 transform -translate-y-1/2 bg-gray-200 text-[#122C56] rounded-full p-2 hover:bg-gray-300 transition shadow-md ${currentImageIndex === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={currentImageIndex === 0}
                                >
                                    &#8249;
                                </button>
                                <button
                                    onClick={nextImage}
                                    className={`absolute right-4 top-1/2 transform -translate-y-1/2 bg-gray-200 text-[#122C56] rounded-full p-2 hover:bg-gray-300 transition shadow-md ${currentImageIndex === selectedPackage.destinationImages.length - 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={currentImageIndex === selectedPackage.destinationImages.length - 1}
                                >
                                    &#8250;
                                </button>
                            </>
                        )}
                        <img
                            src={selectedImage}
                            alt={t("tourPackages.enlargedDestinationAlt")}
                            className="w-full h-full max-h-[85vh] object-contain rounded-lg"
                        />
                    </div>
                </div>
            )}

            {/* Important Notices Section */}
            <div className="mt-16 p-8 max-w-4xl mx-auto bg-white rounded-2xl shadow-xl border-t-4 border-[#C58E2F]">
                <h2 className="text-3xl sm:text-4xl font-bold text-[#122C56] text-center mb-6 drop-shadow-md">
                    {t("tourPackages.importantNotices")}
                </h2>
                <ul className="list-none space-y-4 text-gray-700 text-lg text-center">
                    {[
                        t("tourPackages.notices.transport"),
                        t("tourPackages.notices.children"),
                        t("tourPackages.notices.hygiene"),
                        t("tourPackages.notices.tickets"),
                        t("tourPackages.notices.meals"),
                    ].map((notice, index) => (
                        <li key={index} className="flex items-center justify-center">
                            <span className="w-2 h-2 bg-[#C58E2F] rounded-full mr-2"></span>
                            {notice}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Join with our Luxury Transport System Section */}
            <div className="mt-16 p-8 max-w-6xl mx-auto">
                <h2 className="text-3xl sm:text-4xl font-bold text-[#122C56] text-center mb-8 drop-shadow-md">
                    {t("tourPackages.luxuryTransport")}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {[luxuryTransport1, luxuryTransport2].map((img, index) => (
                        <div key={index} className="relative overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={img}
                                alt={t(`tourPackages.luxuryTransportAlt${index + 1}`)}
                                className="w-full h-full md:h-80 object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Footer Section */}
            <div
                className="relative mt-16 h-64 md:h-96 flex items-center justify-center bg-cover bg-center"
                style={{ backgroundImage: `url(${backgroundImage})` }}
            >
                <div className="absolute inset-0 bg-[#122C56] bg-opacity-70"></div>
                <div className="relative z-10 text-center text-white p-8">
                    <h2 className="text-2xl md:text-4xl font-bold mb-4">{t("tourPackages.getInTouch")}</h2>
                    <p className="text-lg md:text-xl mb-6">{t("tourPackages.getInTouchDescription")}</p>
                    <Link to="/contact-us">
                        <button className="px-6 py-3 bg-[#C58E2F] text-[#FFFFFF] rounded-lg text-lg font-semibold hover:bg-[#A57324] transition transform hover:scale-105">
                            {t("tourPackages.contactUs")}
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default TourPackages;